module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product14-0fcf05f5f2b89997fc668e37189a1e5b.jpg";